export const RawMaterialKey = {
  AVERAGE_TYPE: 'AverageType',
  PRODUCT_ID: 'productId',
  FACILITY_ID: 'facilityId',
  FACILITY_MAIN: 'facilities',
  RAW_MATERIAL_ID: 'rawMaterialId',
  RAW_MATERIAL_MAIN: 'rawMaterialsData',
  RECYCLE_DATA: 'recyclingTypeData',
  SUPPLIER_NAME: 'supplierId',
  RECYCLE: {
    recycle: 'recycle',
    reuse: 'reused',
    fresh: 'fresh'
  },
  RECYCLE_METHOD: 'recyclingType',
  WEIGHT_TF: 'weight',
  COST_TF: 'cost',
  ADD_SUPPLIER: 'supplierData',
  SUPPLIER_ID: 'supplierId',
  RAW_MATERIAL: 'rawMaterial',
  FACILITY: 'facility',
  FUEL_EMISSION: 'fuelEmission',
  ELEC_EMISSION: 'electricityEmission',
  WASTE_EMISSION: 'wasteTreatmentEmission',
  VEHICLE_TYPE: 'vehicletype',
  VOLUME_MATERIAL: 'volumeOfMaterail',
  DISTANCE: 'distanceOfMaterailInputToSupplier',
  STATUS: 'status',
  COMMENT: 'comment'
};

export const RawMaterialLabel = {
  AVERAGE_TYPE: 'Product Name',
  PRODUCT_ID: 'Product Name',
  FACILITY_ID: 'Product Type',
  RAW_MATERIAL_ID: 'Facilities',
  RECYCLE_DATA: 'Raw Materials',
  RECYCLE: {
    recycle: 'Recycle',
    reuse: 'Reused',
    fresh: 'Fresh'
  },
  WEIGHT_TF: 'Weight',
  COST_TF: 'Cost',
  ADD_SUPPLIER: 'Suppliers',
  SINGLE_SUPPLIER: 'Supplier',
  SUPPLIER_NAME: 'Supplier Name',
  SUPPLIER_ID: 'Supplier',
  RAW_MATERIAL: 'Raw Material',
  FACILITY: 'Facility',
  FUEL_EMISSION: 'Fuel Emission',
  ELEC_EMISSION: 'Electricity Emission',
  WASTE_EMISSION: 'Waste Treatment Emission',
  VEHICLE_TYPE: 'Vehicle Type',
  VOLUME_MATERIAL: 'Volume of Material',
  DISTANCE: 'Distance of Material Input to Supplier',
  STATUS_COMMENTS: 'Status & Comments',
  STATUS: 'Status',
  COMMENT: 'Comment'
};
